import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
export default function HomeTwoFun(){
    return(
        <>
            <section className="counter-area counter-bg">
			<div className="container-fluid px-xxl-0">
				<div className="row gx-xxl-0 align-items-center">
					<div className="col-xxl-6 col-xl-6 col-lg-6">
						<div className="count-img-wrapper">
							<img className="count-big1 img-fluid" src="assets/img/counter/count-1.jpg" alt="Count Img" />
							<div className="count-box1 text-center">
								<img src="assets/img/counter/ic-3.png" alt="" />
								<h3 className="counter">1000</h3>
								<p>Getting Rewards</p>
								<Link className="pf-btn" to="#"><i className="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
					<div className="col-xxl-5 col-xl-6 col-lg-6">
						<div className="count-content-wrapper pt-120 mb-110 pl-25 pr-155">
							<h6 className="semi-title semi-title2 pl-0">Fun Fact</h6>
							<h2 className="sect-title mb-30">We Create A Culture
								That Inspires Us</h2>
							<p className="pr-50 pr-lg-0 pr-xs-0">Help our clients succeed by creating brand identities,
								digital
								experiences,
								and print materials. We offer a wide range of Courses For all ages & Levels.
								We offer a wide range of Courses For all ages and Levels.</p>
							<div className="count-wrapper mb-50">
								<div className="count-box d-flex align-items-center">
									<div className="count-text">
										<h3><span className="counter"><CountUp end={6840} /></span> +</h3>
										<p>Happy Customers</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-1.png" alt="icon" />
									</div>
								</div>
								<div className="count-box d-flex align-items-center">
									<div className="count-text">
										<h3><span className="counter"><CountUp end={100} /></span> %</h3>
										<p>Clients Satisfied</p>
									</div>
									<div className="icon">
										<img src="assets/img/counter/ic-2.png" alt="icon" />
									</div>
								</div>
							</div>
							<Link to="/contact" className="theme_btn theme_btn2">Get Started Now</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}